import React from 'react';
export var Currency = function (_a) {
    var value = _a.value, locale = _a.locale, currency = _a.currency;
    var formatted = '';
    if (Intl)
        formatted = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(value);
    else
        value.toLocaleString(locale !== null && locale !== void 0 ? locale : 'en-US', {
            style: 'currency',
            currency: currency !== null && currency !== void 0 ? currency : 'USD'
        });
    return React.createElement(React.Fragment, null, formatted);
};
